export const checkEmailRegex =
  /^(?=[a-zA-Z0-9._%+=]{1,64}@)(?=[a-zA-Z0-9.-]{1,255})[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const validationMessages = {
	Required: '必須項目です',
	TooShortLength: (length: number) => `${length}文字以上入力してください`,
	TooLongLength: (length: number) => `${length}文字以内で入力してください`,
	InvalidEMailAddress: '無効なメールアドレスです',
	InvalidURL: '無効なURLです',
	NotMuchPassword: 'パスワードが一致しません'
}